import services from 'api/services';
import {
  GET_HACKATHON_MATCHES_REQUEST,
  GET_HACKATHON_MATCHES_SUCCESS,
  GET_HACKATHON_MATCHES_FAILURE,
} from './constants';
import { logError } from 'util/errors';

const { ChallengeService } = services;

export const getTournamentMatches = (id) => async (dispatch) => {
  try {
    dispatch({ type: GET_HACKATHON_MATCHES_REQUEST });
    const matches = await ChallengeService.getHackathonMatches(id);
    dispatch({ type: GET_HACKATHON_MATCHES_SUCCESS, matches });
  } catch (ex) {
    logError(ex);
    dispatch({ type: GET_HACKATHON_MATCHES_FAILURE, error: ex.message });
  }
};
